import React, { FunctionComponent } from "react";
import cn from "classnames";

const LoadingSpinner: FunctionComponent<{ classNames?: string }> = ({ classNames }) => (
    // NOTE: Styles for the classes used by this component are defined in commons-ui-styles
    <div className={cn("waitindicator_spinner", classNames)}>
        <div className="ipswitch_waitspinner" />
    </div>
);

export default LoadingSpinner;
